import { IPatternData } from "common/records/Pattern";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const RECEIVE_PATTERN = "@patterns/RECEIVE_PATTERN";
export const RECEIVE_PATTERNS = "@patterns/RECEIVE_PATTERNS";
export const REMOVE_PATTERN = "@patterns/REMOVE_PATTERN";
export const RESET_PATTERN = "@patterns/RESET_PATTERN";

export const PatternActions = {
  receivePattern: (pattern: Partial<IPatternData>) => createAction(RECEIVE_PATTERN, pattern),
  receivePatterns: (patterns: Partial<IPatternData>[]) => createAction(RECEIVE_PATTERNS, { patterns: patterns }),
  removePattern: (patternId: number) => createAction(REMOVE_PATTERN, patternId),
  resetPattern: (patternId: number) => createAction(RESET_PATTERN, patternId),
};

export type PatternActions = ActionsUnion<typeof PatternActions>;
